import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=1807359a&scoped=true&"
import script from "./task-detail.vue?vue&type=script&lang=js&"
export * from "./task-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-detail.vue?vue&type=style&index=0&id=1807359a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807359a",
  null
  
)

export default component.exports